import React from "react";
import { Input } from "reactstrap";
import styles from "./textfield.module.scss";
import Proptypes from "prop-types";

const Textfield = ({ error, touched, type, rows, ...props }) => {
  return (
    <>
      <Input
        type={type}
        rows={type === "textarea" ? rows : undefined}
        {...props}
      />

      {touched && error && (
        <div>
          <div className={styles["error_text"]}>{error}</div>
        </div>
      )}
    </>
  );
};

Textfield.propTypes = {
  error: Proptypes.string,
  touched: Proptypes.bool,
  type: Proptypes.string,
  rows: Proptypes.number,
};

export default Textfield;
